import {change} from "redux-form";
import {generateFetchFieldListAction} from "../../../../apps/KpModule/actions/api";
import {basicContext} from "../../../utils/contextUtils";
import {setFieldVisibility} from "../../../../apps/KpModule/actions";
import {decrypt} from "../../../utils/crypto";
import path from "path";
import {
    getRoleWorkflowConfigs, getStepWorkflowConfig,
    thereIsAtLeastOneInDemand, thereIsAtLeastOneInValidation,
    organizationsHaveSameAxis, thereIsAtLeastOneInPreValidation
} from "../utils/workflowUtils";
import {correctStepAndOrder, getPreviousStepPreviousOrder} from "../utils/workflowUtils";
import {areOrdersContinuous, ordersAreStrictPositive} from "../utils/workflowUtils";
import {substractedItems, getNextStepStatus, getStatusName2} from "../utils/workflowUtils";
import {
    arbitrateButton,
    draftButton,
    returnButton, transmitButton,
    validateDemandeurButton,
    warnAndValidateButton
} from "../utils/demandUtils";
import { ObjectId } from 'bson'

const _ = require('lodash')
const Errors = require("../../../utils/Errors").default

const mailerTemplatePath = path.join(
    global.appRoot,
    global.isProd
        ? 'buildServer/server/models/suiviEngagement/mails/templates/concernedDemands/demandStep'
        : 'src/server/models/suiviEngagement/mails/templates/concernedDemands/demandStep'
);

const sendBulkNotification = async (userMap, subject, content, contextBuilder) => {
    if (!Object.keys(userMap).length) return;
    const mails = Object.keys(userMap).map(mail => ({
        from: 'support@keenpoint.com',
        to: decrypt(mail),
        subject: { template: subject },
        context: contextBuilder(userMap[mail]),
        content: content,
        verbose: { general: true },
        templateDir: mailerTemplatePath
    }));
    try {
        await global.mailer.sendMail(mails);
    } catch (err) {
        console.warn(err);
    }
};

const sendReaderNotifications = async (newObject, roles, subject, content) => {
    if (!roles.length) return;
    try {
        const habs = await global.app.SE.Habilitation.find({
            ...basicContext(context),
            fieldPath: ["user.id"],
            query: {
                "role": {$in: roles.map(id => new global.ObjectID(id))},
                $or: [
                    {"grantedAccess": [], "grantedMesh": []},
                    {"grantedAccess": {$elemMatch: {$in: newObject.organizationAndMesh.map(org => new global.ObjectID(org.id))}}, "grantedMesh":[]},
                    {"grantedAccess":[], "grantedMesh": {$elemMatch: {$in: newObject.organizationAndMesh.map(org => new global.ObjectID(org.id))}}}
                ]
            }
        });
        if (!habs || !habs.length) return;
        const uniqueMails = _.uniq(habs.map(h => h.user.mail));
        const mails = uniqueMails.map(mail => ({
            from: 'support@keenpoint.com',
            to: decrypt(mail),
            subject: {template: subject},
            context: {
                concernedOrgs: newObject.organizationAndMesh.map(org => ' ' + org.name),
                concernedCategory: ' ' + newObject.demandCategory.name,
                concernedNatures: newObject.demandNature.map(nature => ' ' + nature.name),
                concernedPlages: newObject.minMaxAmount.map(minMax => ' ' + minMax.code)
            },
            content: content,
            verbose: {general: true},
            templateDir: mailerTemplatePath
        }));
        await global.mailer.sendMail(mails);
    } catch (error) {
        console.warn(error);
    }
};

const findUsersByRoles = async (roles, orgId) => {
    if (!roles.length) return [];
    const habs = await global.app.SE.Habilitation.find({
        ...basicContext(context),
        fieldPath: ["user.mail"],
        query: {
            "role": {$in: roles.map(id => new global.ObjectID(id))},
            $or: [
                {"grantedAccess": [], "grantedMesh": []},
                {"grantedAccess": {$elemMatch: {$eq: new global.ObjectID(orgId)}}, "grantedMesh":[]},
                {"grantedAccess":[], "grantedMesh": {$elemMatch: {$eq: new global.ObjectID(orgId)}}}
            ]
        }
    });
    return _.uniq((habs || []).map(h => h.user.mail));
};

const finishedDemandsIds =["5", "6", "8", "9"] //refused, approved, closed, abandoned


const steps = [ "preValidation", "demand", "control", "validation", "realization"]

//workFlow.workFlowConfigs =  [ {role : {}, step:'step1', stepOrder:1}, [{role : {}, step:'step1', stepOrder:1} ]

export const entities = [
    {
        name: 'WorkFlow',
        fields: [
            {path : 'organizationAndMesh', type :'OrganizationAndMesh', link: 'MTM'},
            {path: 'demandCategory', type:'DemandCategory', link:'MTO'},
            {path: 'demandNature', type:'DemandNature', link:'MTM'},
            {path: 'minMaxAmount', type: 'MinMaxAmount', link: 'MTM'},
            {
                type: "ArbitrationType",
                nullable: true
            },
            {
                type: "DelegationOption",
            },
            {
                //path: 'ManualWorkFlowConfigs',
                type: 'ManualWorkFlowConfig',
                lazy: true,
                fieldPath: [
                    'workFlowConfigs.id',
                    'workFlowConfigs.role.id',
                ],
                list: true,
                $f: (workFlow,context,callback) => callback(null, []),
                $s: (manualWorkFlowConfigs, workFlow, context, callback) => {
                    const configsAndReaders = {'configs' :[], 'readers': [], 'arbitrators': []}
                    manualWorkFlowConfigs.forEach(config => {
                        const role = config.role
                        if (config['reading']){
                            configsAndReaders['readers'].push(role)
                        }
                        if (config['arbitration']){
                            configsAndReaders['arbitrators'].push(role)
                        }
                        //const previousReaders = workFlow.readers.filter( reader => reader.role.id === role.id)
                        const previousRoleConfigs = getRoleWorkflowConfigs(workFlow.workFlowConfigs, role)
                        steps.forEach(step => {
                            if(config[step]) {    //only checked steps on the dataTable
                                const previousStepConfig = getStepWorkflowConfig(previousRoleConfigs, step) || {}
                                configsAndReaders['configs'].push({
                                    ...previousStepConfig,
                                    role,
                                    step: step,
                                    order: config[`${step}Order`],
                                })
                            }
                        })
                    })
                    workFlow.workFlowConfigs = configsAndReaders['configs']
                    workFlow.readers = configsAndReaders['readers']
                    workFlow.arbitrators = configsAndReaders['arbitrators']
                    callback()
                }
            },
            {
                path: 'workFlowConfigs',
                type:'WorkFlowConfig',
                link: {
                    type: "OTM",
                    onParent: true,     //parent est le workFlow
                    onChild: false,     //child est WorkFlowConfig
                }
            },
            {
                path: 'readers',
                type:'Role',
                link: 'MTM'
            },
            {
                path: 'arbitrators',
                type:'Role',
                link: 'MTM'
            }
        ],
        uniqueProcess: function ( workflowID, configs, organizationsList, demandCategory, demandNatureList, minMaxList, context, callback) {
            const organizationsIDsList = organizationsList.map(organization => new global.ObjectID(organization.id))
            const demandCategoryID = new global.ObjectID(demandCategory.id)
            const demandNatureIDsList = demandNatureList.map( type => new global.ObjectID(type.id))
            const minMaxIDsList = minMaxList.map( minMax => new global.ObjectID(minMax.id))
            global.app.SE.WorkFlow.find({
                ...basicContext(context),
                fieldPath: [],
                query: {
                    "_id": {$ne: new global.ObjectID(workflowID)},
                    "organizationAndMesh": {$elemMatch: { $in: organizationsIDsList }},
                    "demandCategory": {$eq: demandCategoryID },
                    "demandNature": {$elemMatch: { $in: demandNatureIDsList }},
                    "minMaxAmount": {$elemMatch: { $in: minMaxIDsList }}
                }
            }, (e, combinations) => {
                const isWorkflowForProject = demandCategory.category.id === '1'
                if(combinations && combinations.length !== 0) {
                    //and normally it should be only one combination
                    callback(new Errors.ValidationError(context.tc('uniqueWorkflowCombinationError')))
                }
                else if (!configs.length) {
                    callback(new Errors.ValidationError(context.tc('emptyWorkflowError')))
                }
                else if (!ordersAreStrictPositive(configs)){
                    callback(new Errors.ValidationError(context.tc('allOrdersShouldBeStrictPositiveError')))
                }
                else if ( !thereIsAtLeastOneInPreValidation(configs) && isWorkflowForProject) {
                    callback(new Errors.ValidationError(context.tc('atLeastOneFunctionCheckedInPreValidationError')))
                }
                else if ( !thereIsAtLeastOneInDemand(configs)) {
                    callback(new Errors.ValidationError(context.tc('atLeastOneFunctionCheckedInDemandError')))
                }
                else if (!thereIsAtLeastOneInValidation(configs)) {
                    callback(new Errors.ValidationError(context.tc('atLeastOneFunctionCheckedInValidationError')))
                }
                else if (!areOrdersContinuous(configs)){
                    callback(new Errors.ValidationError(context.tc('continuousAndStartFrom1OrdersError')))
                }
                else if (!organizationsHaveSameAxis(organizationsList)){
                    callback(new Errors.ValidationError(context.tc('organizationsHaveSameAxisError')))
                }
                else return callback()
            })


        },
        validateSave: function (newObject, oldObject, context, callback) {
            this.uniqueProcess(newObject.id, newObject.workFlowConfigs, newObject.organizationAndMesh, newObject.demandCategory, newObject.demandNature, newObject.minMaxAmount, context, callback)
        },
        beforeSave: async function(newObject, oldObject, context, callback) {
            try {
                const arbitrationTypeWasModified = (!oldObject && newObject) || (oldObject && newObject && newObject.arbitrationType !== oldObject.arbitrationType)
                    ? {arbitrationType: newObject.arbitrationType} : {}
                const delegationOptionWasModified = (!oldObject && newObject) || (oldObject && newObject && newObject.delegationOption !== oldObject.delegationOption)
                    ? {delegationOption: newObject.delegationOption} : {}

                const demands = await global.app.SE.Demand.find({
                    ...basicContext(context),
                    fieldPath: ["delegateTo.id", "status.id"],
                    query: {
                        organizationAndMesh: { $in: newObject.organizationAndMesh.map(org => new global.ObjectID(org.id)) },
                        demandCategory: { $eq: new global.ObjectID(newObject.demandCategory.id) },
                        demandNature: { $in: newObject.demandNature.map(type => new global.ObjectID(type.id)) },
                        plafond: { $in: newObject.minMaxAmount.map(plafond => new global.ObjectID(plafond.id)) }
                    }
                });

                if (!demands || !demands.length) return callback(null, newObject, oldObject);

                const usersRemovedFromDelegateTo2 = {};
                const usersAddedToStepOrder = {};
                const usersRemovedFromStepOrder = {};

                const activeDemands = demands.filter(demand => !finishedDemandsIds.includes(demand.status.id));

                await Promise.all(activeDemands.map(async (demand) => {
                    let statusUpdate = {};
                    let [correctStep, correctOrder] = demand.workflow;
                    let correctRolesIDs = [];
                    let correctArbitrators = [];

                    if (demand.status.id === '4') { //information request
                        let configsExists = newObject.workFlowConfigs.some(c => c.step === correctStep && c.order === parseInt(correctOrder));
                        while (!configsExists) {
                            [correctStep, correctOrder] = getPreviousStepPreviousOrder(correctStep, parseInt(correctOrder), newObject.workFlowConfigs);
                            configsExists = newObject.workFlowConfigs.some(c => c.step === correctStep && c.order === parseInt(correctOrder));
                        }
                        correctRolesIDs = newObject.workFlowConfigs.filter(c => c.step === correctStep && c.order === parseInt(correctOrder)).map(c => new global.ObjectID(c.role.id));
                    } else if (demand.status.id === "11") { //arbitration
                        correctArbitrators = newObject.arbitrators.map(arbiter => new global.ObjectID(arbiter.id));
                    } else if (demand.status.id !== "1") { //different from draft
                        [correctStep, correctOrder] = correctStepAndOrder(demand.workflow[0], parseInt(demand.workflow[1]), newObject.workFlowConfigs, demand.alreadyTreatedByFunctions);
                        correctRolesIDs = newObject.workFlowConfigs.filter(c => c.step === correctStep && c.order === parseInt(correctOrder)).map(c => new global.ObjectID(c.role.id));
                        statusUpdate = { status: getNextStepStatus(correctStep) };
                    }
                    const correctStatusID = statusUpdate.status || demand.status.id;

                    if (demand.delegateTo && demand.delegateTo.length) {
                        demand.delegateTo.forEach(user => {
                            usersRemovedFromDelegateTo2[user.mail] = usersRemovedFromDelegateTo2[user.mail] || []; //just to get initialized if not already
                            usersRemovedFromDelegateTo2[user.mail].push([demand.demandNumber, demand.status.name2]);
                        });
                    }

                    //added roles + added arbitrators
                    const addedRoles = _.union(substractedItems(correctRolesIDs, demand.contributorsFunctions), substractedItems(correctArbitrators, demand.arbitratorsFunctions));
                    //removed roles + removed arbitrators
                    const removedRoles = _.union(substractedItems(demand.contributorsFunctions, correctRolesIDs), substractedItems(demand.arbitratorsFunctions, correctArbitrators));

                    const [addedMails, removedMails] = await Promise.all([
                        findUsersByRoles(addedRoles, demand.organizationAndMesh),
                        findUsersByRoles(removedRoles, demand.organizationAndMesh)
                    ]);

                    (addedMails || []).forEach(mail => {
                        usersAddedToStepOrder[mail] = usersAddedToStepOrder[mail] || [];
                        usersAddedToStepOrder[mail].push([demand.demandNumber, getStatusName2(correctStatusID)]);
                    });
                    (removedMails || []).forEach(mail => {
                        usersRemovedFromStepOrder[mail] = usersRemovedFromStepOrder[mail] || [];
                        usersRemovedFromStepOrder[mail].push([demand.demandNumber, demand.status.name2]);
                    });

                    await global.app.SE.Demand.collection.updateOne(
                        {_id: new global.ObjectID(demand.id)},
                        {
                            $set: {
                                workflow: [correctStep, correctOrder],
                                contributorsFunctions: correctRolesIDs,
                                arbitratorsFunctions: correctArbitrators,
                                consultantsFunctions: newObject.workFlowConfigs.map(conf => new global.ObjectID(conf.role.id)),
                                allArbitratorsFunctions: newObject.arbitrators.map(arbiter => new global.ObjectID(arbiter.id)),
                                delegateTo: [],
                                ...statusUpdate,
                                ...arbitrationTypeWasModified,
                                ...delegationOptionWasModified
                            }
                        }
                    );
                }));

                const contextBuilder = demands => ({ concernedDemands: demands.map(d => ` ${d[0]} (${_.capitalize(d[1])})`) });
                await sendBulkNotification(usersRemovedFromDelegateTo2, `Délégation retirée`, 'removingDelegation.html', contextBuilder);
                await sendBulkNotification(usersAddedToStepOrder, `Projet(s) en attente de votre décision suite à une modification du Workflow`, 'addedToWorkflow.html', contextBuilder);
                await sendBulkNotification(usersRemovedFromStepOrder, `Intervention annulée`, 'removedFromWorkflow.html', contextBuilder);

                const rolesAddedToReading = (!oldObject && newObject)
                    ? newObject.readers.map( role => new global.ObjectID(role.id))
                    : substractedItems(newObject.readers.map( role => new global.ObjectID(role.id)), oldObject.readers.map( role => new global.ObjectID(role.id)))
                const rolesRemovedFromReading = (!!oldObject && !!newObject)
                    ? substractedItems(oldObject.readers.map( role => new global.ObjectID(role.id)), newObject.readers.map( role => new global.ObjectID(role.id)))
                    : []
                await sendReaderNotifications(newObject, rolesAddedToReading, `Nouveau lecteur assigné`, 'readersWorkflowMails.html');
                await sendReaderNotifications(newObject, rolesRemovedFromReading, `Suppression de vos droits de lecteur`, 'removingReadersWorkflowMails.html');

                callback(null, newObject, oldObject);
            } catch (e) {
                callback(e);
            }
        }
    },
    {
        name: 'WorkFlowConfig',
        fields: [
            {path: 'role', type: 'Role'},
            {path: 'step'},
            {path: 'order', type: 'integer'},
        ],
    },
    {
        name: "ManualWorkFlowConfig",
        type: "mongoInternal",
        //il cree les champs dans le composant père, pour eviter la création des collections pour cette entité
        fields: [
            //en se basant sur les steps
            {path: "role", type: "Role"},    // par defaut le link est celui de dropdown, MTO
            {path: "preValidation", type: "boolean"},
            {path: "preValidationOrder", type: "integer"},
            {path: "demand", type: "boolean"},
            {path: "demandOrder", type: "integer"},
            {path: "control", type: "boolean"},
            {path: "controlOrder", type: "integer"},
            {path: "validation", type: "boolean"},
            {path: "validationOrder", type: "integer"},
            {path: "realization", type: "boolean"},
            {path: "realizationOrder", type: "integer"},
            {path: "arbitration", type: "boolean"},
            {path: "reading", type: "boolean"},
        ]
    }
]


export const module_ = {
    object: 'WorkFlow',
    category: {
        path: 'process',
        icon: 'repeat'
    },
    tKey: 'workflow',
    defaultSortBy: 'demandCategory',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            {path: 'organizationAndMesh', tKey: 'organisation'},
            {path: 'demandCategory', tKey: 'processType', translateName: true},
            {path: 'demandNature', tKey: 'category', translateName: true},
            {path:'minMaxAmount', tKey: 'financialBracket', display: 'code'},
        ],
        form: {
            fields : [
                {
                    path: 'demandCategory',
                    tKey: 'processType',
                    translateName: true,
                    editable: false,
                    fieldPath: ['id', 'name', 'category.id'],
                    subscriptions: {
                        onChange(newValue, oldValue, {module, store}) {
                            const manualWorkFlowConfigsField = module.viewMap.form.fields.find(field => field.path === 'manualWorkFlowConfigs')
                            const preValidationField = manualWorkFlowConfigsField.fields.find(field => field.path === 'preValidation')
                            const preValidationOrderField = manualWorkFlowConfigsField.fields.find(field => field.path === 'preValidationOrder')
                            const realizationField = manualWorkFlowConfigsField.fields.find(field => field.path === 'realization')
                            const realizationOrderField = manualWorkFlowConfigsField.fields.find(field => field.path === 'realizationOrder')

                            if (newValue) {
                                let newWorkflow = _.cloneDeep(manualWorkFlowConfigsField.getValue())
                                newWorkflow.forEach(row =>{
                                    steps.forEach( step => {
                                        row[step] = false
                                        row[step + 'Order'] = 0
                                    })
                                    row['reading'] = false
                                    row['arbitration'] = false
                                })
                                store.dispatch(setFieldVisibility(preValidationField.id, newValue.category.id === '1'))
                                store.dispatch(setFieldVisibility(realizationField.id, newValue.category.id === '1'))
                                store.dispatch(setFieldVisibility(preValidationOrderField.id, newValue.category.id === '1'))
                                store.dispatch(setFieldVisibility(realizationOrderField.id, newValue.category.id === '1'))
                                store.dispatch(change('editObject', 'manualWorkFlowConfigs', newWorkflow))
                            }
                        }
                    }
                },
                {
                    path: 'organizationAndMesh',
                    display: 'fullName',
                    tKey: 'organisation(s)',
                    filters: ['inWorkflowEnabledAxe'],
                    editable: false,
                    fieldPath: ['id', 'fullName', 'joinedEntity'],
                    subscriptions: {    //not yet
                        onChange: (newValue, oldValue, {module, store}) => {
                            // if newObject, we build from 0 on each modification
                            // if editObject, we rebuild the table from the data stored server side (workFlowConfigs)
                            const state = store.getState()

                            store.dispatch(
                                generateFetchFieldListAction(
                                    "Workflow-Role",
                                    store.getState,
                                    { data: { organizations : newValue } }
                                )
                            ).then((response) => {
                                const workFlowConfigs= _.get(state, 'edit.object.data.workFlowConfigs')
                                const readers = _.get(state, 'edit.object.data.readers', [])
                                const arbitrators = _.get(state, 'edit.object.data.arbitrators', [])
                                const roles = response.data || []
                                const manualWorkFlowConfigs = roles.map( role=> {
                                    const previousRoleConfigs = getRoleWorkflowConfigs(workFlowConfigs, role)
                                    const mongoId = new ObjectId()
                                    let object = {id: mongoId.toString(), role: {id: role.id, name: role.profile.name}}
                                    steps.forEach( step => {
                                        const previousStepConfig = getStepWorkflowConfig(previousRoleConfigs, step)
                                        if(!previousStepConfig) {
                                            object[step] = false
                                            object[step + 'Order'] = 0
                                        } else {
                                            object[step] = true
                                            object[step + 'Order'] = previousStepConfig.order
                                        }
                                    })
                                    if (readers===[]){
                                        object["reading"] = false
                                    }
                                    else {
                                        const previousReader = readers.filter( reader => reader.id === role.id)
                                        if (previousReader.length!==0){
                                            object["reading"] = true
                                        }
                                        else {
                                            object["reading"] = false
                                        }
                                    }
                                    if (arbitrators===[]){
                                        object["arbitration"] = false
                                    }
                                    else {
                                        const previousArbitrator = arbitrators.filter( arbitrator => arbitrator.id === role.id)
                                        if (previousArbitrator.length!==0){
                                            object["arbitration"] = true
                                        }
                                        else {
                                            object["arbitration"] = false
                                        }
                                    }
                                    return object
                                })
                                store.dispatch(change('editObject', 'manualWorkFlowConfigs', manualWorkFlowConfigs))
                            })
                        }
                    }
                },
                {
                    path: 'demandNature',
                    tKey: 'categorie(s)',
                    translateName: true,
                    editable: false
                },
                {
                    path:'minMaxAmount',
                    tKey: 'financialBracket(s)',
                    display: 'code',
                    editable: false,
                },
                {
                    path: 'manualWorkFlowConfigs',
                    tKey: 'workflow',
                    type: 'dtObjects',
                    autoGrow: true,
                    fields: [
                        {path: "role", tKey: 'fonction', translateName: true},
                        {path: "preValidation", tKey: 'pré-validation', type: "checkbox"},
                        {path: "preValidationOrder", tKey: 'ordre', type: "editText"},
                        {path: "demand", tKey: 'instruction', type: "checkbox",},
                        {path: "demandOrder", tKey: 'ordre', type: "editText"},
                        {path: "control", tKey: 'contrôle', type: "checkbox"},
                        {path: "controlOrder", tKey: 'ordre', type: "editText"},
                        {path: "validation", type: "checkbox"},
                        {path: "validationOrder", tKey: 'ordre', type: "editText"},
                        {path: "realization", tKey: 'réalisation', type: "checkbox"},
                        {path: "realizationOrder", tKey: 'ordre', type: "editText"},
                        {path: "arbitration", tKey: 'arbitrage', type: "checkbox"},
                        {path: "reading", tKey: 'lecture', type: "checkbox"},
                    ],
                    subscriptions: {
                        onChange (newValue, oldValue, {module, store}){
                            const manualWorkFlowConfigsField = module.viewMap.form.fields.find( field => field.path === 'manualWorkFlowConfigs')
                            const arbitrationTypeField = module.viewMap.form.fields.find( field => field.path === 'arbitrationType')
                            if (newValue && oldValue){
                                if (newValue.length === oldValue.length && JSON.stringify(newValue)!==JSON.stringify(oldValue)){
                                    let cup = []
                                    let arbitration = false
                                    for (let i = 0; i < newValue.length; i++) {
                                        if (newValue[i].arbitration) {arbitration = newValue[i].arbitration} //true
                                        const findOldValue = oldValue.find( row => row.role.id === newValue[i].role.id)
                                        if ( newValue[i] === findOldValue ) {
                                            cup.push(newValue[i])
                                        }
                                        else {
                                            const mongoId = new ObjectId()
                                            let newLine = {id: newValue[i].id || mongoId.toString(), 'role' : newValue[i]['role'], 'reading' : newValue[i]['reading'], 'arbitration' : newValue[i]['arbitration']}
                                            steps.forEach(step => {
                                                newLine[step] = newValue[i][step]
                                                if ( newValue[i][step] === findOldValue[step] ){
                                                    newLine[step + 'Order'] = newValue[i][step + 'Order']
                                                }
                                                else if (newValue[i][step] === true && findOldValue[step] === false){
                                                    newLine[step + 'Order'] = 1
                                                    if ( step === "demand"){
                                                        newLine["reading"] = true
                                                    }
                                                }
                                                else if (newValue[i][step] === false && findOldValue[step] === true){
                                                    newLine[step + 'Order'] = 0
                                                    if ( step === "demand"){
                                                        newLine["reading"] = false
                                                    }
                                                }
                                            })
                                            cup.push(newLine)
                                        }
                                    }
                                    manualWorkFlowConfigsField.setValue(cup)
                                    if (arbitration){
                                        store.dispatch(setFieldVisibility(arbitrationTypeField.id, true))
                                    }
                                    else {
                                        store.dispatch(setFieldVisibility(arbitrationTypeField.id, false))
                                        arbitrationTypeField.setValue(null)
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    path: "delegationOption",
                    required: true,
                    default: {id: "2"},
                    type: "toggle"
                },
                {
                    path: "arbitrationType",
                    required: true,
                    type: 'toggle'
                },
                {path: 'workFlowConfigs', fieldPath: ['role', 'step', 'order'], hidden: true},
                {path: 'readers', fieldPath: ['id'], hidden: true},
                {path: 'arbitrators', fieldPath: ['id'], hidden: true}
            ],
            onOpen: ({ module, state, store }) => {
                const objectMode = state.ui.objectMode
                const arbitrationTypeField = module.viewMap.form.fields.find( field => field.path === 'arbitrationType')
                if(objectMode === 'newObject') {
                    store.dispatch(setFieldVisibility(arbitrationTypeField.id, false))
                }
                else {
                    if ( !arbitrationTypeField.getValue() ){
                        store.dispatch(setFieldVisibility(arbitrationTypeField.id, false))
                    }
                    else {
                        store.dispatch(setFieldVisibility(arbitrationTypeField.id, true))
                    }
                }
            },
            dataLists: [
                "Workflow-Role" //c'est le id d'une dataList qu'on veut ajouter manuellement
            ],
        },
    },
    accesses: [ // goes with the dataList. On va definir les données qu'on veut apporter
        {
            id: "Workflow-Role",
            entity: "Role",
            fieldPath: ['id', 'profile.name'],
            filters: [ 'byOrganizationAndMesh']
        },
    ]
}
